export default __webpack_public_path__ + "static/media/check-box-24-px.7579de1c.svg";